import { Box } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../../assets/images/logo.png";

type TLogo = {
  className: string;
  size: number;
};

export default function HmisLogo(
  props: TLogo = { className: "logo", size: 38 },
) {
  const navigate = useNavigate();

  const dashboardClick = () => {
    navigate("/dashboard");
  };

  return (
    <>
      <Box className={props.className} onClick={dashboardClick}>
        <img
          // src="/logo.png"
          src={logo}
          style={{ height: `${props.size}px`, width: "auto" }}
          alt="Hims Logo"
        ></img>
      </Box>
    </>
  );
}
